import ComparisonResultsPageHero from "../../../../src/components/ComparisonResultsPageHero";
import ComparisonResultPageTextWithImageSection from "../../../../src/components/ComparisonResultPageTextWithImageSection";
import ComparisonResultHeroUserLocation from "../../../../src/components/ComparisonResultHeroUserLocation";
import ComparisonResultGrid from "../../../../src/components/ComparisonResultGrid";
import ComparisonResultColumnContent from "../../../../src/components/ComparisonResultColumnContent";
import ComparisonResultColumnContentBackgroundContainer from "../../../../src/components/ComparisonResultColumnContentBackgroundContainer";
import ComparisonResultGettingStartedBlock from "../../../../src/components/ComarisonResultPageGetStartedBlock";
import ComparisonPageRecommendations from "../../../../src/components/ComparisonPageRecommendations";
import ComparisonResultPageLearnMoreContainer from "../../../../src/components/ComparisonResultPageLearnMoreContainer";
import PersonalLoansIllustration from "../../../../svg/ComparisonResultPageIllustrations/personalloan.svg";
import SplashFinancialLogo from "../../../../svg/supplier-color-logos/SplashFinancial.svg";
import EarnestLogo from "../../../../svg/supplier-color-logos/Earnest.svg";
import LightStreamSVG from "../../../../svg/ComparisonResultGridLogos/personalloans/lightstream.svg";
import SoFiSVG from "../../../../svg/ComparisonResultGridLogos/personalloans/sofi.svg";
import MarcusSVG from "../../../../svg/ComparisonResultGridLogos/personalloans/marcus.svg";
import PropsperSVG from "../../../../svg/ComparisonResultGridLogos/personalloans/prosper.svg";
import PayoffSVG from "../../../../svg/ComparisonResultGridLogos/personalloans/payoff.svg";
import * as React from 'react';
export default {
  ComparisonResultsPageHero,
  ComparisonResultPageTextWithImageSection,
  ComparisonResultHeroUserLocation,
  ComparisonResultGrid,
  ComparisonResultColumnContent,
  ComparisonResultColumnContentBackgroundContainer,
  ComparisonResultGettingStartedBlock,
  ComparisonPageRecommendations,
  ComparisonResultPageLearnMoreContainer,
  PersonalLoansIllustration,
  SplashFinancialLogo,
  EarnestLogo,
  LightStreamSVG,
  SoFiSVG,
  MarcusSVG,
  PropsperSVG,
  PayoffSVG,
  React
};